import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkflowApiService {
  base = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getActions(entity: string, recordId: string) {
    return this.http.get<any>(`${this.base}/api/sys/workflow/${entity}/${recordId}/actions`);
  }

  execute(entity: string, recordId: string, action: string, comment?: string) {
    return this.http.post(`${this.base}/api/sys/workflow/execute`, {
      entity,
      recordId,
      action,
      comment
    });
  }

  timeline(entity: string, recordId: string) {
    return this.http.get<any[]>(`${this.base}/api/sys/workflow/${entity}/${recordId}/timeline`);
  }

  myInbox(roleCode: string) {
    return this.http.get<any[]>(`${this.base}/api/sys/workflow/inbox/my?roleCode=${roleCode}`);
  }
}
